module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-566.017e2a7.woff2";